const _excluded = ["children", "className", "required", "testid", "inputProps", "menuMaxHeight", "skin", "SelectProps"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { TextField as MuiTextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { WideArrowDownward } from "../../icons";
import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
const baseFont = {
  fontFamily: typography.fontFamilyBold,
  fontSize: typography.fontSizeP1
};
const skinToColor = {
  standard: colors.dark900,
  primary: colors.purple800
};
const errorColor = colors.red950;
const disabledColor = colors.dark500;
const placeholderColor = colors.dark400;
const useStyles = makeStyles({
  root: {
    width: undefined,
    marginRight: '-20px',
    '& .MuiSelect-select': {
      backgroundColor: 'transparent'
    }
  },
  inputRoot: _ref => {
    let {
      color
    } = _ref;
    return _objectSpread(_objectSpread({}, baseFont), {}, {
      color,
      // Disable input type=number arrows in Chrome, Safari, Edge, Opera
      '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&.Mui-error': {
        color: errorColor,
        '& $icon': {
          color: errorColor
        }
      },
      // Disable input type=number arrows in Firefox
      '& input[type=number]': {
        '-moz-appearance': 'textfield'
      },
      '&.Mui-error:hover': {
        color: errorColor
      },
      '&.Mui-disabled': {
        color: disabledColor
      },
      '&.MuiInput-underline': {
        '&&&:before': {
          border: 'none',
          right: '32px'
        },
        '&&&:hover:before': {
          borderBottom: '2px solid'
        },
        '&&&.Mui-error:hover:before': {
          borderBottom: '2px solid',
          borderBottomColor: errorColor
        },
        '&&:after': {
          border: 'none',
          right: '16px'
        }
      }
    });
  },
  inputInput: _ref2 => {
    let {
      color
    } = _ref2;
    return _objectSpread(_objectSpread({}, baseFont), {}, {
      paddingTop: '8px',
      paddingBottom: '0px',
      paddingLeft: '0px',
      paddingRight: '0px',
      lineHeight: '24px',
      height: 22,
      '&::placeholder': _objectSpread(_objectSpread({}, baseFont), {}, {
        color,
        opacity: 0.5
      }),
      '&:-webkit-autofill': _objectSpread(_objectSpread({}, baseFont), {}, {
        color
      }),
      '&:autofill': _objectSpread(_objectSpread({}, baseFont), {}, {
        color
      }),
      '&.MuiSelect-select': {
        lineHeight: 'var(--line-height-p1, 24px)',
        paddingRight: '16px'
      }
    });
  },
  helperText: _ref3 => {
    let {
      color
    } = _ref3;
    return _objectSpread(_objectSpread({}, baseFont), {}, {
      color,
      fontSize: 12,
      marginTop: 0,
      marginLeft: 0,
      position: 'absolute',
      bottom: 0,
      left: 0,
      transform: 'translateY(100%)',
      lineHeight: 'normal',
      '&.Mui-disabled': {
        color: disabledColor
      },
      '&.Mui-error': {
        color: errorColor
      }
    });
  },
  menu: {
    maxHeight: props => props.menuMaxHeight
  },
  selectPlaceholder: {
    color: placeholderColor
  },
  icon: _ref4 => {
    let {
      color
    } = _ref4;
    return {
      flexShrink: 0,
      position: 'relative',
      left: '-16px',
      top: '3px',
      pointerEvents: 'none',
      color
    };
  }
});
/** Natural Language Format field is intended to be used as a select input inside a sentence. */
export const NLFField = /*#__PURE__*/forwardRef(function NLFField(props, ref) {
  var _props$InputProps;
  const {
      children,
      className,
      required,
      testid,
      inputProps,
      menuMaxHeight = 300,
      skin = 'standard',
      SelectProps
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const overrides = useStyles({
    menuMaxHeight,
    color: skinToColor[skin]
  });
  const tid = testid || props['data-testid'];
  return /*#__PURE__*/React.createElement(MuiTextField, _extends({
    innerRef: ref,
    "data-testid": tid
  }, rest, {
    select: true,
    className: cn(className, overrides.root),
    variant: "standard",
    size: "small",
    InputProps: {
      ref: (_props$InputProps = props.InputProps) === null || _props$InputProps === void 0 ? void 0 : _props$InputProps.ref,
      required,
      classes: {
        root: overrides.inputRoot,
        input: overrides.inputInput
      }
    },
    SelectProps: _objectSpread({
      IconComponent: _ref5 => {
        let {
          className
        } = _ref5;
        return /*#__PURE__*/React.createElement(WideArrowDownward, {
          width: "16px",
          height: "16px",
          className: cn(className, overrides.icon)
        });
      },
      MenuProps: {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        getContentAnchorEl: null,
        classes: {
          paper: overrides.menu
        }
      },
      SelectDisplayProps: {
        ['data-testid']: tid && "".concat(tid, "-select")
      }
    }, SelectProps) // eslint-disable-line @typescript-eslint/no-explicit-any
    ,
    inputProps: _objectSpread({
      ['data-testid']: tid && "".concat(tid, "-input")
    }, inputProps),
    FormHelperTextProps: {
      ['data-testid']: tid && "".concat(tid, "-helper-text"),
      classes: {
        contained: overrides.helperText
      }
    } // eslint-disable-line @typescript-eslint/no-explicit-any
  }), children);
});